export default {"src":"/_next/static/media/CartilageDamage.498cb663.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};